/*
 * Reducer actions related with GetStart screen
 */
import * as types from './types';

export function setCaseType(caseType) {
  return {
    type: types.SET_CASE_TYPE,
    caseType
  };
}
